<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/32fxQ9/tc-custom/9781398449794.jpg?1718106412616" alt="This image is the cover for the book Time to Choose"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Time to Choose
      </h1>
      <p class="bookDescription body article font2">
        <p>Time to Choose is a collection of short stories of mystery and the supernatural. Tragedy, murder, betrayal, and revenge all haunt the pages within; a witch who uses her powers to rid herself of nuisance neighbours, a demon who terrorises a town in a race against time, a deathbed visit from the Devil himself, vengeful ghosts seeking payback from beyond the grave and the tragic ghost of an unloved, unwanted child seeking a playmate for eternity. From all corners of the UK and her coastal waters to New York and California comes a collection of spiteful, vengeful and sometimes tragic spirits who cannot or will not rest until they have wrought their fury on their human victims.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lesley Anne Wright
      </h2>
      
      <p class="authorDescription body article">Lesley has always enjoyed writing but began doing so in earnest when she retired from her post as a primary school headteacher. She has always been interested in the supernatural and mystery, and is also an avid reader. She lives in North Tyneside, with her pet Fox Terrier, Darcy, and has three daughters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fb5297d